import styled from 'styled-components';

export const Container = styled.div`
    display: flex;

    align-items: center;
    justify-content: center;
    
    width: 100%;
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 3rem;
    width: 90%;
    max-width: 800px;

    .category {
        color: black;
        font-size: 1.3rem;
        font-weight: 700;
        margin: .2rem 0rem;
    }
`;

export const TitleDate = styled.h3`
    margin-top: 4rem;
    font-size: 2.5rem;
`;

export const InfoCard = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin: 1rem 0rem;
    padding: .3rem .5rem;
    background-color: rgb(118,118,128,.12);
    border-radius: 9px;

    .info-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 4rem;
    }

`;

export const Button = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    border: none;
    color: white;
    font-family: Inter;
    font-weight: 300;
    font-size: large;
    background-color: black;
    padding: 1.5rem 1rem;
    margin-top: 4rem;
    border-radius: 15px;
`;

export const ButtonSwitch = styled.button`
    display: flex;
    width: 45px;
    height: 28px;
    align-items: center;
    justify-content: center;
    border: none;
    color: black;
    font-family: Inter;
    font-weight: 400;
    font-size: large;
    border-radius: 7px;
    padding: 0rem 1rem;
`;

export const SwitchContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: white;
    border-radius: 10px;


    .switchContent {
        display: flex;
        align-items: end;
        justify-content: space-between;
        width: 100%;
        padding: .5rem 1rem;

        .iconGroup {

            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;

            .iconGroupTitle {
                display: flex;
                align-items: end;
                justify-content: center;
                margin: 0rem .5rem;
            }
        }
    }

`;